import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import TextEditorButton from 'flarum/common/components/TextEditorButton';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import classList from 'flarum/common/utils/classList';

export default class VideoUploadButton extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    // 监听上传状态变化，触发重新渲染以显示 loading
    this.attrs.uploader.on('uploading', () => {
      m.redraw();
    });

    this.attrs.uploader.on('uploaded', () => {
      // reset the button for a new upload
      if (this.$('form')[0]) {
        this.$('form')[0].reset();
      }
      // redraw to reflect uploader.uploading in the DOM
      m.redraw();
    });

    this.attrs.uploader.on('success', () => {
      // 上传成功后的处理
      m.redraw();
    });

    this.attrs.uploader.on('failure', () => {
      // 上传失败后的处理
      m.redraw();
    });
  }

  view() {
    // 注意：显示/隐藏逻辑已经在 controlItems 中处理，这里不再检查
    // 如果组件被添加到 items，就应该显示
    
    const isUploading = this.attrs.uploader.uploading;
    const buttonText = isUploading
      ? app.translator.trans('tf-cns-upload-video.forum.buttons.uploading')
      : app.translator.trans('tf-cns-upload-video.forum.buttons.upload_video');

    return (
      <TextEditorButton
        className={classList([
          'Button',
          'hasIcon',
          'tf-video-upload-button',
          'item-tf-video-upload',
          !isUploading && 'Button--icon',
          !isUploading && 'Button--link',
          isUploading && 'uploading',
          isUploading && 'Button--loading',
        ])}
        icon={!isUploading && 'fas fa-video'}
        onclick={this.uploadButtonClicked.bind(this)}
        disabled={this.attrs.disabled || isUploading}
        title={buttonText}
      >
        {isUploading && <LoadingIndicator size="small" display="inline" className="Button-icon" />}
        {isUploading && <span className="Button-label">{buttonText}</span>}
        <form>
          <input type="file" accept="video/*" multiple={true} onchange={this.process.bind(this)} disabled={isUploading} />
        </form>
      </TextEditorButton>
    );
  }

  /**
   * Process the upload event.
   *
   * @param e
   */
  process(e) {
    // get the file from the input field
    const files = this.$('input').prop('files');

    if (files.length === 0) {
      return;
    }

    // 过滤出视频文件
    const videoFiles = Array.from(files).filter(file => file.type.startsWith('video/'));
    
    if (videoFiles.length === 0) {
      app.alerts.show(
        { type: 'error' },
        app.translator.trans('tf-cns-upload-video.forum.states.no_video_files')
      );
      return;
    }

    // 获取编辑器实例
    const composer = this.attrs.composer;
    const editor = composer && composer.editor ? composer.editor : null;
    
    this.attrs.uploader.upload(videoFiles, true, editor);
  }

  /**
   * Event handler for upload button being clicked
   *
   * @param {PointerEvent} e
   */
  uploadButtonClicked(e) {
    // Trigger click on hidden input element
    // (Opens file dialog)
    this.$('input').click();
  }
}

